__turbopack_context__.v({
  "backdrop": "CoreEmailDisclaimer-module-scss-module__pzLn3q__backdrop",
  "close": "CoreEmailDisclaimer-module-scss-module__pzLn3q__close",
  "close-icon": "CoreEmailDisclaimer-module-scss-module__pzLn3q__close-icon",
  "content": "CoreEmailDisclaimer-module-scss-module__pzLn3q__content",
  "content-wrapper": "CoreEmailDisclaimer-module-scss-module__pzLn3q__content-wrapper",
  "cta": "CoreEmailDisclaimer-module-scss-module__pzLn3q__cta",
  "description": "CoreEmailDisclaimer-module-scss-module__pzLn3q__description",
  "fade-in": "CoreEmailDisclaimer-module-scss-module__pzLn3q__fade-in",
  "fade-in-slide-up": "CoreEmailDisclaimer-module-scss-module__pzLn3q__fade-in-slide-up",
  "fade-out": "CoreEmailDisclaimer-module-scss-module__pzLn3q__fade-out",
  "fade-out-slide-down": "CoreEmailDisclaimer-module-scss-module__pzLn3q__fade-out-slide-down",
  "positioner": "CoreEmailDisclaimer-module-scss-module__pzLn3q__positioner",
});
